export interface INotification {
  title: string;
  description: string;
  severity?: Severity;
  clearAfterMs?: number;
}
export enum Severity {
  INFO = 'INFO',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
}

export interface IAlerts {
  title: string;
  errors: { label: string }[];
  severity?: Severity;
}
